import React, { useMemo } from 'react';
import cn from 'classnames';
import { useParams } from 'react-router-dom';
import { getMenu } from './utils';
import StyledMenu from '../../common/StyledMenu/StyledMenu';
import styles from './HouseNav.module.scss';
import { useSelector } from 'react-redux';

const getId = (value) => {
  const id = Number(value);

  return !isNaN(id) ? id : undefined;
};

const HouseNav = ({ className }) => {
  const params = useParams();

  const addressId = useMemo(() => getId(params.pageId), [params.pageId]);

  const { isAvailable, houseId } =
    useSelector((state) => state.housingStockStore.houseAvailable) || {};

  const showActionModal = houseId === addressId && !!isAvailable;

  return (
    <StyledMenu
      selectedKeys={[params.pageTab]}
      className={cn(styles.root, className)}
      items={getMenu(params)}
      disabled={!showActionModal}
    />
  );
};

export default HouseNav;
